import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsIceSkateNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.857 3.587a5.5 5.5 0 016.719 3.684l.305.993a14.5 14.5 0 009.876 9.678l4.817 1.376A7.482 7.482 0 0145 26.512 5.488 5.488 0 0139.512 32h-.376l.667 1h3.364A4.833 4.833 0 0148 37.833 3.167 3.167 0 0144.833 41H3.5A3.5 3.5 0 010 37.5v-1A3.5 3.5 0 013.5 33h2.697l.924-1.385A7.503 7.503 0 012 24.5v-1.38a9.5 9.5 0 01.366-2.61L5.44 9.749a5.5 5.5 0 013.825-3.791zM10.469 32l-2.666 4H3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h41.333a.167.167 0 00.167-.167C45 36.821 44.18 36 43.167 36h-4.97l-2.666-4h-3.062l-2.666 4H16.197l-2.666-4zm6.381-.429L17.803 33h10.394l.745-1.118c-1.5-.16-2.98-.48-4.416-.959A18.108 18.108 0 0018.818 30a.476.476 0 00-.332.136l-.84.839a3.498 3.498 0 01-.796.596zM21.71 8.154a2.5 2.5 0 00-3.055-1.675l-8.59 2.37a2.5 2.5 0 00-1.739 1.723L5.25 21.335A6.5 6.5 0 005 23.12V24.5A4.5 4.5 0 009.5 29h5.672a.5.5 0 00.353-.146l.84-.84A3.475 3.475 0 0118.817 27c2.255 0 4.515.363 6.656 1.077 1.834.611 3.755.923 5.688.923h8.35A2.488 2.488 0 0042 26.512a4.482 4.482 0 00-3.25-4.31l-4.817-1.376a17.5 17.5 0 01-2.646-.992l-4.721 4.721-2.126-2.117 4.17-4.169a17.51 17.51 0 01-2.125-1.777L22.494 20.5l-2.126-2.117 4.158-4.174a17.485 17.485 0 01-1.535-2.578L18.3 16.321l-2.125-2.117 5.655-5.656z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsIceSkateNormalLarge;
